// Core packages
import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";

// Custom packages
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ConfigService } from "src/app/shared/services/config.service";

/**
 * Script start
 */

@Component({
  selector: "app-company-search",
  templateUrl: "./company-search.component.html",
  styleUrls: ["./company-search.component.scss"]
})
export class CompanySearchComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  @Output('eventCompanySelected') eventCompanySelected = new EventEmitter<string>();

  lang = this.translateService.currentLang || this.translateService.defaultLang;

  // BEGIN - Form
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};

  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true
    }
  };
  // END - Form

  companySelected: "";

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private translateService: TranslateService,
    private cookieService: CookieService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    private companiesService: CompaniesService,
  ) {

  }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Get current lang
    this.lang = this.cookieService.get("lang") || this.configService.defaultLang;

    this.initForm();
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Init company field form
   *
   * @since 1.0.0
   */
  initForm(): void {
    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: 'col-12',
            type: 'autocomplete',
            key: 'company',
            templateOptions: {
              customLabel: this.translateService.instant('searchDocs.components.companies.filter'),
              placeholder: this.translateService.instant('searchDocs.components.companies.name'),
              bindLabel: 'name',
              bindValue: '_id',
              search$: this.companiesService.getList.bind(this),
              typeToSearchText: this.translateService.instant('common.words.typeToSearch', { minTermLength: 1 }),
              clearAllText: this.translateService.instant('common.words.clearAll'),
              notFoundText: this.translateService.instant('common.words.notFound'),
              loadingText: this.translateService.instant('common.words.loading'),
            },
            expressionProperties: {
              "templateOptions.onChange": (model: any): void => {
                if (this.companySelected !== model.company) {
                  this.companySelected = model.company;
                  this.eventCompanySelected.emit(model.company);
                }
              },
            }
          },
        ]
      }
    ];
  }
  
  /**
   * Handle reste selected value
   */
  onResetSelected(): void {
    this.form.reset();
  }
}
